
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Markalar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    document.title = "3D Yazıcı Markaları - Anycubic, Creality, Elegoo, Bambu Lab | Ankara";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da tüm 3D yazıcı markalarında uzman servis. Anycubic, Creality, Elegoo, Bambu Lab, Flashforge ve daha fazlası için profesyonel tamir ve bakım hizmeti.');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "3D Yazıcı Markaları",
      "description": "Servis verdiğimiz 3D yazıcı markaları",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Brand",
            "name": "Anycubic"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Brand",
            "name": "Creality"
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Brand",
            "name": "Elegoo"
          }
        },
        {
          "@type": "ListItem",
          "position": 4,
          "item": {
            "@type": "Brand",
            "name": "Bambu LAB"
          }
        },
        {
          "@type": "ListItem",
          "position": 5,
          "item": {
            "@type": "Brand",
            "name": "Flashforge"
          }
        },
        {
          "@type": "ListItem",
          "position": 6,
          "item": {
            "@type": "Brand",
            "name": "Snapmaker"
          }
        },
        {
          "@type": "ListItem",
          "position": 7,
          "item": {
            "@type": "Brand",
            "name": "Flsun"
          }
        }
      ]
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const brands = [
    {
      name: "Anycubic",
      slug: "anycubic",
      logo: "https://public.readdy.ai/ai/img_res/e62fcc96a129ecb1b3e40cb4fef75d6e.jpg",
      description: "Anycubic 3D yazıcılarınız için profesyonel tamir ve bakım hizmeti",
      models: "Photon, Kobra, Vyper, Mega serisi"
    },
    {
      name: "Creality",
      slug: "creality",
      logo: "https://readdy.ai/api/search-image?query=Creality%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=creality-logo&orientation=landscape",
      description: "Creality Ender ve CR serisi için uzman servis desteği",
      models: "Ender 3, CR-10, K1, Sermoon serisi"
    },
    {
      name: "Elegoo",
      slug: "elegoo",
      logo: "https://readdy.ai/api/search-image?query=Elegoo%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=elegoo-logo&orientation=landscape",
      description: "Elegoo Mars ve Saturn serisi reçine yazıcılar için özel hizmet",
      models: "Mars, Saturn, Neptune serisi"
    },
    {
      name: "Bambu LAB",
      slug: "bambu-lab",
      logo: "https://readdy.ai/api/search-image?query=Bambu%20LAB%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=bambulab-logo&orientation=landscape",
      description: "Yeni nesil Bambu LAB yazıcıları için profesyonel destek",
      models: "X1 Carbon, P1P, A1 serisi"
    },
    {
      name: "Flashforge",
      slug: "flashforge",
      logo: "https://readdy.ai/api/search-image?query=Flashforge%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=flashforge-logo&orientation=landscape",
      description: "Flashforge Adventurer ve Creator serisi için uzman hizmet",
      models: "Adventurer, Creator, Guider serisi"
    },
    {
      name: "Snapmaker",
      slug: "snapmaker",
      logo: "https://readdy.ai/api/search-image?query=Snapmaker%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=snapmaker-logo&orientation=landscape",
      description: "Çok fonksiyonlu Snapmaker cihazları için özel servis",
      models: "Snapmaker 2.0, Artisan, J1 serisi"
    },
    {
      name: "Flsun",
      slug: "flsun",
      logo: "https://readdy.ai/api/search-image?query=Flsun%203D%20printer%20brand%20logo%20on%20white%20background%2C%20clean%20corporate%20branding%2C%20professional%20technology%20company%20logo%2C%20high%20resolution&width=300&height=150&seq=flsun-logo&orientation=landscape",
      description: "Delta tipi Flsun yazıcıları için profesyonel bakım",
      models: "QQ-S Pro, Super Racer, V400 serisi"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Servis Verdiğimiz <span className="text-red-600">3D Yazıcı Markaları</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Ankara'da tüm popüler 3D yazıcı markalarında uzman servis hizmeti sunuyoruz. 
              Orijinal yedek parça ve profesyonel teknik destek garantisi.
            </p>
          </div>
        </div>
      </section>

      {/* Brands Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {brands.map((brand, index) => (
              <Link
                key={index}
                to={`/markalar/${brand.slug}`}
                className={`bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="h-40 bg-gray-50 flex items-center justify-center p-8 border-b border-gray-100">
                  <img 
                    src={brand.logo}
                    alt={`${brand.name} Logo`}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{brand.name}</h3>
                  <p className="text-gray-600 mb-4">{brand.description}</p>
                  <div className="mb-4">
                    <span className="text-sm font-semibold text-gray-700">Popüler Modeller:</span>
                    <p className="text-sm text-gray-600 mt-1">{brand.models}</p>
                  </div>
                  <div className="flex items-center text-red-600 font-medium">
                    Detaylı Bilgi
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Tüm Markalarda Profesyonel Hizmet
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Hangi marka 3D yazıcınız olursa olsun, uzman ekibimizle yanınızdayız
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: "ri-tools-line",
                title: "Orijinal Parça",
                description: "Tüm markalar için orijinal yedek parça tedariki"
              },
              {
                icon: "ri-user-star-line",
                title: "Uzman Ekip",
                description: "Marka özelinde eğitimli teknisyen kadrosu"
              },
              {
                icon: "ri-shield-check-line",
                title: "Garanti",
                description: "Yapılan tüm işlemlerde garanti kapsamı"
              },
              {
                icon: "ri-customer-service-2-line",
                title: "Teknik Destek",
                description: "Sürekli teknik destek ve danışmanlık"
              }
            ].map((item, index) => (
              <div 
                key={index}
                className={`text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${400 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            3D Yazıcınız Hangi Marka Olursa Olsun
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Uzman ekibimizle hemen iletişime geçin. Ücretsiz ön değerlendirme ve teklif alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              Randevu Al
            </Link>
            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              WhatsApp ile İletişim
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/markalar" className="hover:text-white transition-colors">Markalar</Link></li>
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0312 394 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
